import {createContext, ReactNode, useContext, useState} from "react";

const ProgrammaticScrollContext = createContext({
    isProgrammatic: false,
    setIsProgrammatic: (_value: boolean) => {
    }
});

interface Props {
    children: ReactNode;
}

export const ProgrammaticScrollProvider = ({children}: Props) => {
    const [isProgrammatic, setIsProgrammatic] = useState(false);
    
    return (
        <ProgrammaticScrollContext.Provider value={{isProgrammatic, setIsProgrammatic}}>
            {children}
        </ProgrammaticScrollContext.Provider>
    );
};

export const useProgrammaticScroll = () => useContext(ProgrammaticScrollContext);
